<template>
  <thuHoiDialog
    :widthDialog="'450px'"
    :classDialog="'refuse-dialog'"
    :isOpen="isOpen"
    :modalAppendToBody="true"
    :appendToBody="true"
    :dialogTitle="'Từ chối xử lý'"
    :labelFieldForm="'Lý do từ chối'"
    @closeDialog="$emit('closeDialog')"
    @dialogClosed="$emit('dialogClosed')"
    @save="save"
  >
  </thuHoiDialog>
</template>

<script>
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbIncomingProcessService from "../../../services/vbIncomingProcessService";

  export default {
    name: "tuChoiDialog",
    mixins: [handleRequestErrorMixin],
    props: ["vbIncomingDocId", "isOpen"],
    components: {
      thuHoiDialog: () => import('../../doc-out/components/thuHoiDialog')
    },
    computed: {

      parentRoute() {
        return this.$route.path.split("/")[3];
      },
    },
    methods: {

      save(event) {
        vbIncomingProcessService
          .tuChoi({content: event.form.comment}, this.vbIncomingDocId)
          .then(response => {
            this.$message({message: 'Từ chối chuyển xử lý thành công', type: 'success'});
            this.$emit("success", {vbIncomingDoc: response.data});
          })
          .catch((error) => {
            this.commonHandleRequestError(error);
            throw error;
          });
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/tuChoiDialog.vue